<template>
    <multiselect
        :value="selected_packages"
        :options="packages"
        @input="updateValueAction"
        :multiple="true"
        track-by="id"
        label="name"
        class="package-multi-select"
        :clearOnSelect="false"
        :closeOnSelect="false"
    >
        <template slot="beforeList">
            <button class="clear-all-button m-5" v-show="selected_packages.length" @click="$emit('input', [])">
                Clear All <i></i>
            </button>
        </template>
    </multiselect>
</template>

<script>
export default {
    name: "package-multi-select",
    data () {
        return {
        }
    },
    props: {
        packages: Array,
        selected_packages: Array
    },
    methods: {
        updateValueAction(value) {
            this.$emit('input', value);
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!--You can't do scoped styles when overriding a child components styles-->
<style lang="scss">
.package-multi-select {
    .multiselect__tags {
        border-radius: 0;
        border-color: rgb(130, 130, 130);

        .multiselect__tag {
            background: #26A2D9;

            .multiselect__tag-icon:focus,
            .multiselect__tag-icon:hover {
                background: #26A2D9;
            }
        }
    }

    .multiselect__option--highlight {
        background: #26A2D9;
    }

    .multiselect__option--highlight:after {
        background: #26A2D9;
    }

    // This is kinda dumb, I overrode the background color so I have to manual revert the background color for when it's selected
    .multiselect__option--selected.multiselect__option--highlight {
        background: #ff6a6a;
    }

    .multiselect__option--selected.multiselect__option--highlight:after {
        background: #ff6a6a;
    }

    .clear-all-button {
        border-radius: 5px;
        color: white;
        background-color: #ff6a6a;
        border-style: none;

        i::after {
            content: "×";
            color: black;
            font-size: 14px;
        }

        i:focus:after,
        i:hover:after {
            color: white;
        }
    }
}
</style>



// WEBPACK FOOTER //
// package-multi-select.vue?2d659ce4